import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations, LANGS } from "./translations";

const LanguageContext = createContext(null);

const detectInitial = () => {
  const stored = typeof window !== "undefined" ? localStorage.getItem("mysymp_lang") : null;
  if (stored && LANGS.includes(stored)) return stored;
  const nav = typeof navigator !== "undefined" ? navigator.language.slice(0, 2) : "de";
  return LANGS.includes(nav) ? nav : "de";
};

export const LanguageProvider = ({ children, initialLang }) => {
  const [lang, setLangState] = useState(initialLang || detectInitial);

  const setLang = useCallback((l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    localStorage.setItem("mysymp_lang", l);
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
